// Append-only transformation/audit log for Smart Asset Import.
//
// Every change the pipeline makes to source data — a date reformat, a generated code,
// an assumed QTY, a dedup decision — is recorded here with before/after and a reason.
// This is the literal implementation of the "document every transformation" data rule,
// and it is the evidence trail behind any row that reaches auto-accept.

/**
 * Create a fresh transform log.
 * Each entry: { rowId, field, op, before, after, reason, source }
 *   source ∈ 'deterministic' | 'human' | 'learned'
 */
export const createTransformLog = () => {
  const entries = [];

  const add = ({ rowId = '', field = '', op = '', before = '', after = '', reason = '', source = 'deterministic' }) => {
    entries.push({ rowId, field, op, before, after, reason, source });
  };

  const toJSON = () => JSON.stringify(entries, null, 2);

  const csvEscape = (v) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const toCSV = () => {
    const header = ['rowId', 'field', 'op', 'before', 'after', 'reason', 'source'];
    const lines = [header.join(',')];
    entries.forEach((e) => {
      lines.push(header.map((k) => csvEscape(e[k])).join(','));
    });
    return lines.join('\n');
  };

  return { entries, add, toJSON, toCSV };
};
